import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import GuiaSitePremium from '../../src/GuiaSitePremium';
import '../../src/index.css';
import {initAnalytics} from '../../src/analytics';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback={<div className="site-route-loader" role="status">Carregando conteúdo...</div>}>
      <GuiaSitePremium />
    </Suspense>
  </StrictMode>,
);

initAnalytics();

